import _ from 'lodash/fp'
import { createTypes, createActions, createReducer, assignLeft } from '@fe/redux/reducers/util'

const namespace = 'resetPassword'

const typeKeys = [
  'SUBMIT_REQUEST',
  'SUBMIT_SUCCESS',
  'SUBMIT_ERROR',

  'CONFIRM_REQUEST',
  'CONFIRM_SUCCESS',
  'CONFIRM_ERROR'
]

export const types = createTypes(typeKeys, namespace)
export const actions = createActions(types)

export const initialState = {
  loading: false,
  success: false,
  error: null,

  confirmLoading: false,
  confirmSuccess: false,
  confirmError: null
}

function createSelectors () {
  const ns = _.get(namespace)

  const loading = _.flow(ns, _.get('loading'))
  const success = _.flow(ns, _.get('success'))
  const error = _.flow(ns, _.get('error'))

  const confirmLoading = _.flow(ns, _.get('confirmLoading'))
  const confirmSuccess = _.flow(ns, _.get('confirmSuccess'))
  const confirmError = _.flow(ns, _.get('confirmError'))

  return {
    loading,
    success,
    error,
    confirmLoading,
    confirmSuccess,
    confirmError
  }
}

export const selectors = createSelectors()

const reducer = {
  [types.SUBMIT_REQUEST]: p => assignLeft({ loading: true, success: false, error: false }),
  [types.SUBMIT_SUCCESS]: p => assignLeft({ loading: false, success: true, error: false }),
  [types.SUBMIT_ERROR]: p => assignLeft({ loading: false, error: p }),

  [types.CONFIRM_REQUEST]: p => assignLeft({ confirmLoading: true, confirmSuccess: false, confirmError: false }),
  [types.CONFIRM_SUCCESS]: p => assignLeft({ confirmLoading: false, confirmSuccess: true, confirmError: false }),
  [types.CONFIRM_ERROR]: p => assignLeft({ confirmLoading: false, confirmError: p })
}

export default createReducer(initialState, reducer)
